import { createI18n } from 'vue-i18n'
import { tr } from './tr'
import { en } from './en'
import { nl } from './nl'
import { ru } from './ru'
import {ar} from './ar'

const Languages = {
    tr: tr,
    en: en,
    nl: nl,
    ru: ru,
    ar: ar,
}

const i18n = createI18n({
    locale: window.LANGUAGE_CODE ?? 'tr',
    legacy: false,
    globalInjection: true,
    silentTranslationWarn: true,
    messages: Languages,
    dateTimeFormats: {
        'tr-TR': {
            short: {
                year: 'numeric',
                month: 'short',
                day: 'numeric'
            },
            long: {
                year: 'numeric',
                month: 'short',
                day: 'numeric',
                weekday: 'short',
                hour: 'numeric',
                minute: 'numeric'
            }
        }
    },
    numberFormats: {
        tr: {
            currency: {
                style: 'currency',
                currency: 'TRY',
                symbol: '₺'
            }
        },
        en: {
            currency: {
                style: 'currency',
                currency: 'USD',
                symbol: '$'
            }
        },
    }
})

export default i18n
